import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"
import ItemService from "../../../services/commonService";


export const fetchTransactionList = createAsyncThunk("getTransactionListData", async(value) => {
    const {name} = value
    const res = await ItemService.getTransactionListData(value);
    res.name=name;
    return res
})

export const addTransactionRecord = createAsyncThunk("addTransactionRecord", async(value) => {
    let res 
    if(!value.edit){
        res = await ItemService.addTransactionData(value);
    } else {
        res = await ItemService.updateTransactionData(value);
    }  
    return res
})

export const fetchTransactionListById = createAsyncThunk("getTransactionListDataById", async(param) => {
    const {page} = param
    const res = await ItemService.getTransactionListDataById(param);
    res.name=page;
    return res
})


const getTransactionListData = createSlice({
    name:"commonTransactionList",
    initialState: {
        isLoading:false,
        page:{},
        isError:false,
    },
    reducers: {
       
    },
    extraReducers:(builder) => {
        builder.addCase(fetchTransactionList.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(fetchTransactionList.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.page[payload.name]=payload
            state.isError=false
        })
        builder.addCase(addTransactionRecord.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(addTransactionRecord.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.isError=false;
        })
        // builder.addCase(fetchTransactionListById.pending,(state,action) => {
        //     state.isLoading=true;
        // })
        // builder.addCase(fetchTransactionListById.fulfilled, (state,{payload}) => {
        //     state.isLoading=false;
        //     state.page[payload.name]=payload
        //     state.isError=false
        // })
        // builder.addCase(addTransactionRecord.pending,(state,action) => {
        //     state.isLoading=true;
        // })
        // builder.addCase(addTransactionRecord.fulfilled, (state,{payload}) => {
        //     state.isLoading=false;
        //     state.isError=false;
        // })
        // builder.addCase(deleteTransactionRecord.pending,(state,action) => {
        //     state.isLoading=true;
        // })
        // builder.addCase(deleteTransactionRecord.fulfilled, (state,{payload}) => {
        //     state.isLoading=false;
        //     state.isError=false;
        // })
    }
})

export default getTransactionListData.reducer;